import React, { createContext, useContext, useState, useCallback } from "react";
import { MORE, MORE_LABELS } from "./i18n_more";

const STRINGS = {
  en: {
    lang_name: "English",
    // nav
    nav_home: "Home", nav_categories: "Categories", nav_how: "How It Works",
    nav_about: "About", nav_contact: "Contact", nav_terms: "Terms",
    login: "Login / Sign Up", logout: "Logout", my_history: "My History",
    // hero
    hero_eyebrow: "FREE USED-ELECTRONICS PRICE CHECK",
    hero_title_1: "Know Your", hero_title_2: "Resale Value.",
    hero_sub: "Get a fair estimate for your used phone, laptop or gadget in under 2 minutes. See the full price breakdown and compare estimates across {n} real platforms. No login needed.",
    chip_realtime: "No login needed", chip_trusted: "Clear price breakdown",
    chip_bestvalue: "100% free", chip_savetime: "Under 2 minutes",
    search_placeholder: "Search your device (e.g. iPhone 15, MacBook, PS5...)",
    voice_listening: "Listening... speak now",
    voice_error: "Could not hear you. Please try again.",
    voice_unsupported: "Voice search is not supported on this browser.",
    voice_hint: "Tap mic to speak",
    share_results: "Share on WhatsApp",
    sharing: "Preparing image...",
    share_caption: "Best resale price for",
    share_via: "via Valuelix",
    // categories
    explore: "EXPLORE CATEGORIES", find_device: "Find Your Device",
    categories_count: "11 Categories",
    // how it works
    how_eyebrow: "HOW VALUELIX WORKS",
    how_title: "From device to decision in three simple steps.",
    step1_t: "Pick Your Device", step1_d: "Choose a category and enter your model.",
    step2_t: "Answer a Few Questions", step2_d: "Tell us condition, purchase year and accessories.",
    step3_t: "See Your Estimate", step3_d: "Get a price range with breakdown, then compare platform estimates.",
    trust_free_t: "100% Free", trust_free_d: "No hidden charges.",
    trust_fast_t: "Fast & Easy", trust_fast_d: "Takes less than 2 minutes.",
    trust_secure_t: "Privacy First", trust_secure_d: "No name or phone needed for a price.",
    trust_millions_t: "For Everyone", trust_millions_d: "Simple enough for anyone.",
    // valuate
    val_title: "Get Your Best Price",
    val_step_category: "1. Select Category",
    val_step_model: "2. Enter Device Model",
    model_placeholder: "e.g. iPhone 13, Galaxy S23, MacBook Air",
    q_condition: "3. What is the condition?",
    q_year: "4. Which year did you buy it?",
    q_accessories: "5. Which accessories do you have?",
    q_bill: "I have the original purchase bill",
    bill_hint: "Optional. Buyers usually pay a little more when a bill is available.",
    bill_uploaded: "Bill available",
    remove: "Remove",
    get_best_price: "Get My Estimate",
    calculating: "Calculating your estimate...",
    model_required: "Please enter your device model name",
    spec_required: "Please select all device details",
    fill_all: "Please fill all fields to get accurate price.",
    auto_detected: "Auto-detected from model",
    model_hint: "Tip: add storage or variant (e.g. iPhone 15 128GB) — we'll auto-fill the rest.",
    identified: "Product identified",
    current_new_price: "Current New Price",
    change_product: "Change",
    searching: "Searching...",
    no_match: "Not in our list — you can still continue with the typed name.",
    cant_find: "Can't find your model? Continue manually →",
    manual_mode: "Entering details manually — pick the specs below.",
    market_reference: "New price used",
    limited_data: "Limited market data — estimate based on available product information.",
    enter_new_price: "Current new price of this model (in ₹)",
    enter_new_price_hint: "We'll use this as the reference to estimate your resale value.",
    enter_manually: "Enter details manually",
    enter_price_required: "Please enter the current new price to get your resale estimate.",
    price_disclaimer: "Today's price for a NEW unit of this model (check Amazon or Flipkart). A wrong price gives a wrong estimate.",
    price_prefilled: "Pre-filled from our catalog. Change it only if today's new price is different.",
    mod_mobile_screen: "Screen has been replaced (tick only if yes)",
    mod_tv_lines: "Screen has lines or patches (tick only if yes)",
    mod_earbuds_both: "One side not working properly (tick only if yes)",
    mod_watch_batt: "Battery does not last a full day (tick only if yes)",
    mod_appliance_rust: "Body has rust or heavy dents (tick only if yes)",
    mod_tablet_net: "Network Type",
    mod_net_wifi: "Wi-Fi Only", mod_net_cell: "Wi-Fi + SIM Cellular",
    mod_camera_inc: "What's included?",
    mod_cam_body: "Body Only", mod_cam_lens: "With Lens",
    mod_gaming_ctrl: "Controllers",
    mod_ctrl1: "1 Controller", mod_ctrl2: "2 Controllers",
    back: "Back",
    // results
    res_prices_for: "Resale value of",
    res_best_value: "Highest estimate",
    est_resale: "Resale value",
    est_note: "Based on current used-market prices. Final offer depends on inspection.",
    platform_offers: "Platform estimates",
    how_est_title: "How we calculated this",
    how_model: "Exact model",
    how_newprice: "Current new price",
    how_age: "Product age",
    how_condition: "Condition",
    how_variant: "Variant",
    how_demand: "Resale demand",
    age_this_year: "This year",
    age_year: "yr",
    demand_high: "High", demand_med: "Medium", demand_low: "Low",
    visit_platform: "Visit platform",
    est_price: "Valuelix estimate",
    sort_by: "Sort by",
    sort_high: "Price: High to Low",
    sort_low: "Price: Low to High",
    disclaimer_title: "Please Note",
    disclaimer: "\"Real price\" comes from recent dealer offers, prices users actually received, or market checks by Valuelix. \"Estimate\" comes from our formula. Neither is an offer from Valuelix or any company. The final price is decided after physical inspection.",
    new_search: "New Search",
    save_login: "Login to save your search history",
    // history
    hist_title: "My Search History",
    hist_empty: "No searches yet. Value your first device!",
    clear_history: "Clear History",
    value_again: "Value Again",
    login_required: "Please login to view your history.",
    // footer
    footer_tagline: "Better Value. Smarter Choices.",
    footer_quick: "Quick Links",
    footer_legal: "Legal",
    footer_about: "About Us", footer_terms: "Terms & Conditions",
    footer_contact: "Contact Us", footer_privacy: "Privacy Policy",
    footer_rights: "All rights reserved.",
    footer_desc: "A free tool to estimate the resale value of used electronics in India. Valuelix does not buy devices.",
    footer_domain: "valuelix.com",
    footer_disclaimer: "Prices shown are estimates only. Actual resale value may vary.",
    // about
    about_title: "About Valuelix",
    about_p1: "Valuelix is a free tool that estimates the resale value of used electronics in India. Valuelix does not buy devices. We show you a fair price range, explain exactly how it was calculated, and compare estimates for the real platforms where you can sell.",
    about_p2: "Selling a used phone, laptop or appliance in India can be confusing. Every platform quotes a different price. Valuelix removes the guesswork by showing you estimated prices side by side, so you can decide with confidence.",
    about_p3: "We built Valuelix to be so simple that anyone — from a college student in a metro to a first-time internet user in a village — can check their device value in under two minutes, in English or Hindi.",
    about_mission_t: "Our Mission",
    about_mission_d: "To bring transparency to India's used electronics market and ensure every seller gets a fair price.",
    about_stat1: "{n}", about_stat1_l: "Real platforms compared",
    about_stat2: "11", about_stat2_l: "Device Categories",
    about_stat3: "2 min", about_stat3_l: "Average Time",
    // contact
    contact_title: "Contact Us",
    contact_sub: "Have a question or feedback? We'd love to hear from you.",
    contact_name: "Your Name", contact_email: "Your Email",
    contact_msg: "Your Message", contact_send: "Send Message",
    contact_sent: "Thanks! Your message has been sent.",
    contact_email_l: "Email", contact_phone_l: "Phone", contact_addr_l: "Address",
    contact_addr_v: "India",
    contact_form_note: "We reply by email. Your message is stored only to answer you.",
    contact_failed: "Could not send. Please try again.",
    // V2: results, breakdown, confidence
    compared_across: "Compared across {n} platforms",
    platforms_word: "Real platforms compared",
    est_range_note: "Fair price range for your device today. Rounded to ₹500.",
    confidence: "Confidence",
    conf_High: "High", conf_Medium: "Medium", conf_Low: "Low",
    conf_reason_model_not_in_catalog: "Model not in our catalog yet — based on the new price you entered.",
    conf_reason_price_date_unknown: "New-price data for this model is not yet verified with a date.",
    conf_reason_price_data_old: "New-price data for this model is older than 6 months.",
    conf_reason_custom_new_price: "You changed the new price, so we used your value.",
    conf_reason_very_old_device: "Very old devices vary a lot in price.",
    conf_reason_dealer_offers_used: "Includes real offers from local dealers.",
    last_updated: "Price data updated",
    not_verified: "Not yet verified",
    bd_new_price: "Current new price",
    bd_variant: "Storage / RAM / size",
    bd_age: "Age ({y} yr)",
    bd_condition: "Condition",
    bd_battery: "Battery health",
    bd_accessories: "Box & accessories",
    bd_bill: "Bill available",
    bd_damage: "Reported issue",
    bd_extra_cellular: "Cellular model",
    bd_extra_lens: "Kit lens included",
    bd_brand: "Brand demand",
    bd_extra_controller: "Second controller",
    bd_dealer_blend: "Real dealer offers ({n})",
    bd_cap: "Kept below new price",
    bd_estimate: "Your estimate",
    group_instant: "Instant buyback (quick sale)",
    group_marketplace: "Marketplace listing (sell yourself)",
    row_label: "Valuelix estimate based on typical pricing. Not an official offer from this platform. Final price after inspection.",
    download_card: "Download result card",
    share_whatsapp: "Share on WhatsApp",
    how_calc_link: "How we calculate prices",
    q_battery: "Battery health (optional)",
    bat_90: "90% or more", bat_85: "85 – 89%", bat_80: "80 – 84%", bat_low: "Below 80%", bat_unknown: "Don't know",
    optional: "Optional",
    year_older: "2018 or older",
    choose_variant: "Choose storage / RAM",
    use_anyway: "My model is not listed — find “{q}” with AI",
    variants_word: "variants",
    new_from: "New from",
    launched: "Launched",
    launch_price: "Launch price",
    est_label: "Estimated",
    conf_reason_new_price_estimated: "Today's new price is estimated from the launch price (not yet verified).",
    conf_reason_market_data_used: "Includes real sale prices reported by users or dealers.",
    price_updated_on: "Price data updated on {d}",
    price_from_launch: "New price estimated from launch price {p} ({d})",
    price_stale_note: "(older than 30 days)",
    price_typed_by_you: "New price entered by you",
    bd_market_data: "Real sale prices ({n})",
    unknown_note: "This model is not in our list yet. We estimated it as {seg} {brand} using the new price you entered, and added it to our list for review.",
    seg_phone_budget: "a budget", seg_phone_mid: "a mid-range", seg_phone_premium: "a premium", seg_phone_flagship: "a flagship",
    seg_laptop_budget: "a budget", seg_laptop_mid: "a mid-range", seg_laptop_premium: "a premium", seg_laptop_flagship: "a high-end", seg_laptop_gaming: "a gaming",
    device_word_mobile: "phone", device_word_laptop: "laptop",
    sold_q: "Did you sell it? For how much?",
    sold_hint: "Optional and anonymous — no name or phone. It helps everyone get fairer prices.",
    sold_price: "Price you received (₹)",
    sold_pincode: "Pincode (optional)",
    sold_submit: "Share anonymously",
    sold_thanks: "Thank you! Your report makes future estimates more accurate.",
    sold_not_yet: "Not sold yet",
    sold_yes: "Yes, I sold it",
    // V2 Stage 3: real prices, dealers
    basis_real: "Real price",
    basis_estimate: "Estimate",
    src_dealer_offer: "Dealer offers: {p} ({n} offers, last 60 days)",
    src_sold: "Recently sold: {p} ({n} people, last {d} days)",
    src_market_check: "Market check: {d}",
    src_adjusted: "Based on {n} real prices for this model, adjusted for your variant and condition.",
    src_estimate: "Estimate calculated by our formula — no recent real prices for this device yet.",
    src_partial: "Estimate, partly based on {n} recent real price(s).",
    src_list_title: "Real data used",
    kind_dealer_offer: "Dealer offers", kind_sold: "Sold by users", kind_market_check: "Market checks",
    latest_on: "latest {d}",
    conf_reason_real_prices_used: "Based on recent real prices.",
    tab_online: "Online estimate",
    tab_dealers: "Nearby dealers",
    channels_title: "Where you can sell",
    channel_band: "Typical for this type of buyer",
    channel_note: "Valuelix estimate based on typical pricing. Not an offer from any company listed. Final price after inspection.",
    nd_title: "Get real offers from verified shops near you",
    nd_sub: "We share only your device, its condition and your pincode. No name, no phone number.",
    nd_pincode: "Your 6-digit pincode",
    nd_find: "Find dealers",
    nd_location: "Use my location",
    nd_none: "No approved dealers near you yet. Try a nearby pincode, or use the online estimate.",
    nd_open: "Open now", nd_closed: "Closed now",
    nd_hours: "Hours",
    nd_same_pincode: "Same pincode", nd_nearby_area: "Nearby area", nd_same_district: "Same district", nd_same_region: "Your region",
    nd_km: "{k} km away",
    nd_directions: "Get directions",
    nd_get_offer: "Get offer",
    nd_ask_all: "Ask all selected ({n})",
    nd_sent: "Request sent anonymously. Dealers will reply with offers.",
    nd_see_offers: "See my offers",
    nd_requested: "Requested",
    ds_kicker: "Sell nearby · Best cash offer",
    ds_title: "Get a real cash offer from a verified shop near you",
    ds_sub: "Shops often pay more than online buyers. Compare offers in minutes — free.",
    ds_p1: "Verified shops", ds_p2: "Number stays private", ds_p3: "No fee",
    ds_locate: "Find shops near me",
    ds_pincode: "Use my pincode",
    nd_or: "or",
    nd_searching: "Finding shops near you…",
    nd_found: "{n} shops near you",
    nd_hint: "Tap “Use my location” or enter your pincode to see shops near you.",
    nd_know_shop: "Own a shop? Join Valuelix as a dealer",
    nd_no_location: "Location is not available on this device — please enter your pincode.",
    nd_loc_denied: "Location permission was not given — please enter your pincode.",
    mo_title: "My dealer offers",
    mo_sub: "Highest offer first. Your phone number is never shared unless you choose one dealer below.",
    mo_empty: "No requests yet. Check a price and tap \"Nearby dealers\" to ask shops for offers.",
    mo_waiting: "Waiting for offers from",
    mo_valid: "Valid till {d}",
    mo_expired: "Expired",
    mo_share: "Share my number with this dealer",
    mo_phone: "Your 10-digit mobile number",
    mo_consent: "I agree to share my phone number with this one dealer only, so they can contact me about selling my device. I can ask Valuelix to delete it any time.",
    mo_share_btn: "Share with this dealer only",
    mo_shared: "Number shared with this dealer only",
    mo_report: "Report this dealer",
    mo_report_reason: "What went wrong?",
    mo_report_sent: "Thank you. Valuelix will review this report.",
    mo_offer: "Offer",
    nav_dealers: "For Dealers",
    fd_title: "Get genuine customers for your shop — free",
    fd_sub: "Customers near you check their device price on Valuelix and ask verified shops for offers. You see the device, condition and area, and send your offer. The customer's number reaches you only if they choose your shop.",
    fd_points: "Free for now|Only verified shops (we review every application)|Customers' privacy protected|Simple dashboard on your phone",
    fd_apply: "Apply as a dealer",
    fd_login: "Dealer login",
    da_title: "Dealer application",
    da_shop: "Shop details", da_location: "Location", da_hours: "Opening hours", da_buy: "What you buy", da_photos: "Shop photos", da_account: "Login details",
    da_shop_name: "Shop name", da_owner: "Owner name", da_phone: "Shop mobile number", da_address: "Full address", da_area: "Area / locality", da_city: "City", da_pincode: "Pincode",
    da_use_location: "Use my current location (stand inside the shop)", da_location_ok: "Location saved", da_maps: "Or paste your Google Maps link (optional)",
    da_open: "Opens at", da_close: "Closes at", da_closed_days: "Closed on",
    da_categories: "Categories you buy", da_brands: "Brands you buy (leave empty for all)", da_min: "Minimum price you buy (₹)", da_max: "Maximum price you buy (₹)",
    da_pct: "Your usual offer as % of Valuelix estimate",
    da_front: "Shop front with board (required)", da_photo2: "Inside the shop (optional)", da_photo3: "Another photo (optional)",
    da_email: "Email", da_password: "Password (min 8 characters)",
    da_submit: "Submit application",
    da_terms: "By applying you agree to the Terms and confirm the details are true. Valuelix reviews every shop before it is shown to customers.",
    dl_title: "Dealer login", dl_submit: "Log in", dl_no_account: "New dealer? Apply here",
    dd_title: "Dealer dashboard", dd_requests: "Requests", dd_contacts: "Contacts shared", dd_profile: "Profile",
    dd_none: "No requests yet. Customers near you will appear here.",
    dd_estimate: "Valuelix estimate", dd_suggested: "Suggested by your rules", dd_send: "Send offer", dd_amount: "Your offer (₹)", dd_note: "Note (optional)", dd_valid: "Valid for days",
    dd_offer_sent: "Offer sent", dd_your_offer: "Your offer", dd_customer_phone: "Customer phone (shared with you)",
    dd_mark: "Mark as", st_new: "New", st_offered: "Offered", st_contacted: "Contacted", st_sold: "Sold", st_closed: "Closed",
    dd_logout: "Log out", dd_save: "Save changes", dd_saved: "Saved",
    dd_add_photo: "Add photo", dd_photo_review: "New photos appear after Valuelix reviews them.", dd_pending: "Pending review", dd_approved: "Approved",
    dd_no_contacts: "No customer has shared a number with you yet.",
    // legal + consent
    nav_privacy: "Privacy Policy", nav_disclaimer: "Disclaimer",
    privacy_title: "Privacy Policy",
    disclaimer_page_title: "Disclaimer",
    legal_updated: "Last updated: 15 October 2026",
    consent_text: "We use optional analytics cookies to understand how visitors use Valuelix and improve it. Nothing is tracked unless you accept.",
    consent_accept: "Accept analytics",
    consent_reject: "Only necessary",
    consent_more: "Privacy Policy",
    cookie_settings: "Cookie settings",
    // terms
    terms_title: "Terms & Conditions",
    terms_updated: "Last updated: 15 October 2026",
  },
  hi: {
    lang_name: "हिंदी",
    nav_home: "होम", nav_categories: "श्रेणियाँ", nav_how: "कैसे काम करता है",
    nav_about: "हमारे बारे में", nav_contact: "संपर्क", nav_terms: "नियम",
    login: "लॉगिन / साइन अप", logout: "लॉगआउट", my_history: "मेरा इतिहास",
    hero_eyebrow: "पुराने इलेक्ट्रॉनिक्स की मुफ्त कीमत जाँच",
    hero_title_1: "जानिए अपनी", hero_title_2: "रीसेल वैल्यू।",
    hero_sub: "2 मिनट में अपने पुराने फोन, लैपटॉप या गैजेट की सही अनुमानित कीमत जानें। पूरा हिसाब देखें और {n} असली प्लेटफॉर्म के अनुमान की तुलना करें। लॉगिन की ज़रूरत नहीं।",
    chip_realtime: "लॉगिन ज़रूरी नहीं", chip_trusted: "कीमत का पूरा हिसाब",
    chip_bestvalue: "100% मुफ्त", chip_savetime: "2 मिनट से कम",
    search_placeholder: "अपना डिवाइस खोजें (जैसे iPhone 15, MacBook, PS5...)",
    voice_listening: "सुन रहे हैं... अब बोलें",
    voice_error: "आपकी आवाज़ नहीं सुनी। कृपया फिर कोशिश करें।",
    voice_unsupported: "इस ब्राउज़र में वॉइस सर्च समर्थित नहीं है।",
    voice_hint: "बोलने के लिए माइक दबाएं",
    share_results: "व्हाट्सएप पर शेयर करें",
    sharing: "इमेज तैयार हो रही है...",
    share_caption: "सबसे अच्छी रीसेल कीमत",
    share_via: "वैल्युएलिक्स के ज़रिए",
    explore: "श्रेणियाँ देखें", find_device: "अपना डिवाइस चुनें",
    categories_count: "11 श्रेणियाँ",
    how_eyebrow: "वैल्युएलिक्स कैसे काम करता है",
    how_title: "तीन आसान स्टेप में डिवाइस से फैसले तक।",
    step1_t: "अपना डिवाइस चुनें", step1_d: "श्रेणी चुनें और मॉडल का नाम डालें।",
    step2_t: "कुछ सवालों के जवाब दें", step2_d: "हमें स्थिति, खरीद का साल और एक्सेसरीज़ बताएं।",
    step3_t: "अपना अनुमान देखें", step3_d: "हिसाब के साथ कीमत की रेंज पाएं, फिर प्लेटफॉर्म अनुमान की तुलना करें।",
    trust_free_t: "100% मुफ्त", trust_free_d: "कोई छिपा शुल्क नहीं।",
    trust_fast_t: "तेज़ और आसान", trust_fast_d: "2 मिनट से भी कम में।",
    trust_secure_t: "प्राइवेसी पहले", trust_secure_d: "कीमत देखने के लिए नाम या फोन नहीं चाहिए।",
    trust_millions_t: "सबके लिए", trust_millions_d: "हर किसी के लिए आसान।",
    val_title: "अपनी बेस्ट कीमत पाएं",
    val_step_category: "1. श्रेणी चुनें",
    val_step_model: "2. डिवाइस मॉडल डालें",
    model_placeholder: "जैसे iPhone 13, Galaxy S23, MacBook Air",
    q_condition: "3. डिवाइस की स्थिति क्या है?",
    q_year: "4. आपने इसे किस साल खरीदा था?",
    q_accessories: "5. आपके पास कौन सी एक्सेसरीज़ हैं?",
    q_bill: "मेरे पास ओरिजिनल खरीद का बिल है",
    bill_hint: "वैकल्पिक। बिल होने पर खरीदार आमतौर पर थोड़ा ज़्यादा देते हैं।",
    bill_uploaded: "बिल उपलब्ध",
    remove: "हटाएं",
    get_best_price: "मेरा अनुमान देखें",
    calculating: "आपका अनुमान निकाला जा रहा है...",
    model_required: "कृपया अपने डिवाइस का मॉडल नाम डालें",
    spec_required: "कृपया डिवाइस की सभी जानकारी चुनें",
    fill_all: "सटीक कीमत पाने के लिए कृपया सभी फ़ील्ड भरें।",
    auto_detected: "मॉडल से पहचाना गया",
    model_hint: "टिप: स्टोरेज या वेरिएंट जोड़ें (जैसे iPhone 15 128GB) — बाकी हम खुद भर देंगे।",
    identified: "उत्पाद पहचाना गया",
    current_new_price: "मौजूदा नई कीमत",
    change_product: "बदलें",
    searching: "खोज रहे हैं...",
    no_match: "हमारी सूची में नहीं है — आप टाइप किए नाम से आगे बढ़ सकते हैं।",
    cant_find: "अपना मॉडल नहीं मिला? मैन्युअली आगे बढ़ें →",
    manual_mode: "जानकारी मैन्युअली भरी जा रही है — नीचे स्पेक्स चुनें।",
    market_reference: "ली गई नई कीमत",
    limited_data: "सीमित मार्केट डेटा — उपलब्ध जानकारी के आधार पर अनुमान।",
    enter_new_price: "इस मॉडल की मौजूदा नई कीमत (₹ में)",
    enter_new_price_hint: "हम इसे रीसेल वैल्यू के अनुमान के लिए रेफरेंस के रूप में उपयोग करेंगे।",
    enter_manually: "विवरण मैन्युअली भरें",
    enter_price_required: "रीसेल अनुमान पाने के लिए कृपया मौजूदा नई कीमत डालें।",
    price_disclaimer: "इस मॉडल के नए पीस की आज की कीमत (Amazon या Flipkart पर देखें)। गलत कीमत से अनुमान गलत आएगा।",
    price_prefilled: "हमारे कैटलॉग से भरी गई। आज की नई कीमत अलग हो तभी बदलें।",
    mod_mobile_screen: "स्क्रीन बदली गई है (हाँ हो तभी टिक करें)",
    mod_tv_lines: "स्क्रीन पर लाइनें या धब्बे हैं (हाँ हो तभी टिक करें)",
    mod_earbuds_both: "एक साइड ठीक से काम नहीं करती (हाँ हो तभी टिक करें)",
    mod_watch_batt: "बैटरी पूरे दिन नहीं चलती (हाँ हो तभी टिक करें)",
    mod_appliance_rust: "बॉडी पर जंग या भारी डेंट हैं (हाँ हो तभी टिक करें)",
    mod_tablet_net: "नेटवर्क टाइप",
    mod_net_wifi: "केवल Wi-Fi", mod_net_cell: "Wi-Fi + SIM सेल्युलर",
    mod_camera_inc: "इसमें क्या शामिल है?",
    mod_cam_body: "केवल बॉडी", mod_cam_lens: "लेंस के साथ",
    mod_gaming_ctrl: "कंट्रोलर",
    mod_ctrl1: "1 कंट्रोलर", mod_ctrl2: "2 कंट्रोलर",
    back: "वापस",
    res_prices_for: "रीसेल वैल्यू",
    res_best_value: "सबसे ज़्यादा अनुमान",
    est_resale: "रीसेल वैल्यू",
    est_note: "मौजूदा यूज़्ड-मार्केट कीमतों पर आधारित। अंतिम कीमत जाँच पर निर्भर।",
    platform_offers: "प्लेटफॉर्म अनुमान",
    how_est_title: "हमने यह कैसे निकाला",
    how_model: "सटीक मॉडल",
    how_newprice: "मौजूदा नई कीमत",
    how_age: "उत्पाद की आयु",
    how_condition: "कंडीशन",
    how_variant: "वेरिएंट",
    how_demand: "रीसेल मांग",
    age_this_year: "इस साल",
    age_year: "साल",
    demand_high: "ज़्यादा", demand_med: "मध्यम", demand_low: "कम",
    visit_platform: "प्लेटफॉर्म देखें",
    est_price: "वैल्युएलिक्स अनुमान",
    sort_by: "क्रमबद्ध करें",
    sort_high: "कीमत: ज़्यादा से कम",
    sort_low: "कीमत: कम से ज़्यादा",
    disclaimer_title: "कृपया ध्यान दें",
    disclaimer: "\"असली कीमत\" हाल के डीलर ऑफर, यूज़र्स को असल में मिली कीमतों, या वैल्युएलिक्स की मार्केट जाँच से आती है। \"अनुमान\" हमारे फॉर्मूले से आता है। दोनों में से कोई भी वैल्युएलिक्स या किसी कंपनी का ऑफर नहीं है। अंतिम कीमत फिजिकल जाँच के बाद तय होती है।",
    new_search: "नई खोज",
    save_login: "अपना इतिहास सहेजने के लिए लॉगिन करें",
    hist_title: "मेरा खोज इतिहास",
    hist_empty: "अभी तक कोई खोज नहीं। अपने पहले डिवाइस की वैल्यू जानें!",
    clear_history: "इतिहास साफ़ करें",
    value_again: "फिर से वैल्यू करें",
    login_required: "अपना इतिहास देखने के लिए लॉगिन करें।",
    footer_tagline: "बेहतर वैल्यू। स्मार्ट फैसले।",
    footer_quick: "त्वरित लिंक",
    footer_legal: "कानूनी",
    footer_about: "हमारे बारे में", footer_terms: "नियम और शर्तें",
    footer_contact: "संपर्क करें", footer_privacy: "गोपनीयता नीति",
    footer_rights: "सर्वाधिकार सुरक्षित।",
    footer_desc: "भारत में पुराने इलेक्ट्रॉनिक्स की रीसेल वैल्यू जानने का मुफ्त टूल। वैल्युएलिक्स डिवाइस नहीं खरीदता।",
    footer_domain: "valuelix.com",
    footer_disclaimer: "दिखाई गई कीमतें केवल अनुमान हैं। वास्तविक रीसेल वैल्यू भिन्न हो सकती है।",
    about_title: "वैल्युएलिक्स के बारे में",
    about_p1: "वैल्युएलिक्स भारत में पुराने इलेक्ट्रॉनिक्स की रीसेल वैल्यू का अनुमान देने वाला मुफ्त टूल है। वैल्युएलिक्स डिवाइस नहीं खरीदता। हम आपको सही कीमत की रेंज, उसका पूरा हिसाब और असली प्लेटफॉर्म के अनुमान दिखाते हैं।",
    about_p2: "भारत में पुराना फोन, लैपटॉप या उपकरण बेचना उलझन भरा हो सकता है। हर प्लेटफॉर्म अलग कीमत देता है। वैल्युएलिक्स अनुमानित कीमतें साथ-साथ दिखाकर यह उलझन दूर करता है।",
    about_p3: "हमने वैल्युएलिक्स को इतना आसान बनाया है कि कोई भी — शहर का छात्र हो या गाँव का पहली बार इंटरनेट इस्तेमाल करने वाला — दो मिनट में अपने डिवाइस की वैल्यू जान सके, अंग्रेज़ी या हिंदी में।",
    about_mission_t: "हमारा मिशन",
    about_mission_d: "भारत के पुराने इलेक्ट्रॉनिक्स बाज़ार में पारदर्शिता लाना और हर विक्रेता को उचित कीमत दिलाना।",
    about_stat1: "{n}", about_stat1_l: "असली प्लेटफॉर्म की तुलना",
    about_stat2: "11", about_stat2_l: "डिवाइस श्रेणियाँ",
    about_stat3: "2 मिनट", about_stat3_l: "औसत समय",
    contact_title: "संपर्क करें",
    contact_sub: "कोई सवाल या सुझाव है? हमें बताएं।",
    contact_name: "आपका नाम", contact_email: "आपका ईमेल",
    contact_msg: "आपका संदेश", contact_send: "संदेश भेजें",
    contact_sent: "धन्यवाद! आपका संदेश भेज दिया गया है।",
    contact_email_l: "ईमेल", contact_phone_l: "फोन", contact_addr_l: "पता",
    contact_addr_v: "भारत",
    contact_form_note: "हम ईमेल से जवाब देते हैं। आपका संदेश सिर्फ जवाब देने के लिए रखा जाता है।",
    contact_failed: "भेजा नहीं जा सका। कृपया फिर कोशिश करें।",
    compared_across: "{n} प्लेटफॉर्म की तुलना",
    platforms_word: "असली प्लेटफॉर्म की तुलना",
    est_range_note: "आज आपके डिवाइस की सही कीमत की रेंज। ₹500 तक राउंड की गई।",
    confidence: "भरोसा",
    conf_High: "ज़्यादा", conf_Medium: "मध्यम", conf_Low: "कम",
    conf_reason_model_not_in_catalog: "यह मॉडल अभी हमारे कैटलॉग में नहीं है — आपकी डाली नई कीमत पर आधारित।",
    conf_reason_price_date_unknown: "इस मॉडल की नई कीमत अभी तारीख के साथ सत्यापित नहीं है।",
    conf_reason_price_data_old: "इस मॉडल की नई कीमत का डेटा 6 महीने से पुराना है।",
    conf_reason_custom_new_price: "आपने नई कीमत बदली, इसलिए आपकी कीमत ली गई।",
    conf_reason_very_old_device: "बहुत पुराने डिवाइस की कीमत में काफी फर्क होता है।",
    conf_reason_dealer_offers_used: "इसमें लोकल डीलरों के असली ऑफर शामिल हैं।",
    last_updated: "कीमत डेटा अपडेट",
    not_verified: "अभी सत्यापित नहीं",
    bd_new_price: "मौजूदा नई कीमत",
    bd_variant: "स्टोरेज / रैम / साइज़",
    bd_age: "उम्र ({y} साल)",
    bd_condition: "कंडीशन",
    bd_battery: "बैटरी हेल्थ",
    bd_accessories: "बॉक्स और एक्सेसरीज़",
    bd_bill: "बिल उपलब्ध",
    bd_damage: "बताई गई खराबी",
    bd_extra_cellular: "सेल्युलर मॉडल",
    bd_extra_lens: "किट लेंस शामिल",
    bd_brand: "ब्रांड की मांग",
    bd_extra_controller: "दूसरा कंट्रोलर",
    bd_dealer_blend: "डीलरों के असली ऑफर ({n})",
    bd_cap: "नई कीमत से कम रखा गया",
    bd_estimate: "आपका अनुमान",
    group_instant: "तुरंत बिक्री (इंस्टेंट बायबैक)",
    group_marketplace: "मार्केटप्लेस (खुद बेचें)",
    row_label: "आम कीमतों पर आधारित वैल्युएलिक्स अनुमान। यह इस प्लेटफॉर्म का आधिकारिक ऑफर नहीं है। अंतिम कीमत जाँच के बाद।",
    download_card: "रिज़ल्ट कार्ड डाउनलोड करें",
    share_whatsapp: "व्हाट्सएप पर शेयर करें",
    how_calc_link: "हम कीमत कैसे निकालते हैं",
    q_battery: "बैटरी हेल्थ (वैकल्पिक)",
    bat_90: "90% या ज़्यादा", bat_85: "85 – 89%", bat_80: "80 – 84%", bat_low: "80% से कम", bat_unknown: "पता नहीं",
    optional: "वैकल्पिक",
    year_older: "2018 या उससे पहले",
    choose_variant: "स्टोरेज / रैम चुनें",
    use_anyway: "मेरा मॉडल लिस्ट में नहीं — “{q}” AI से खोजें",
    variants_word: "वेरिएंट",
    new_from: "नया",
    launched: "लॉन्च",
    launch_price: "लॉन्च कीमत",
    est_label: "अनुमानित",
    conf_reason_new_price_estimated: "आज की नई कीमत लॉन्च कीमत से अनुमानित है (अभी सत्यापित नहीं)।",
    conf_reason_market_data_used: "इसमें यूज़र्स या डीलरों की बताई असली बिक्री कीमतें शामिल हैं।",
    price_updated_on: "कीमत डेटा अपडेट: {d}",
    price_from_launch: "नई कीमत लॉन्च कीमत {p} ({d}) से अनुमानित",
    price_stale_note: "(30 दिन से पुराना)",
    price_typed_by_you: "नई कीमत आपने डाली",
    bd_market_data: "असली बिक्री कीमतें ({n})",
    unknown_note: "यह मॉडल अभी हमारी सूची में नहीं है। आपकी डाली नई कीमत से इसे {seg} {brand} मानकर अनुमान लगाया गया, और इसे जाँच के लिए सूची में जोड़ दिया गया है।",
    seg_phone_budget: "बजट", seg_phone_mid: "मिड-रेंज", seg_phone_premium: "प्रीमियम", seg_phone_flagship: "फ्लैगशिप",
    seg_laptop_budget: "बजट", seg_laptop_mid: "मिड-रेंज", seg_laptop_premium: "प्रीमियम", seg_laptop_flagship: "हाई-एंड", seg_laptop_gaming: "गेमिंग",
    device_word_mobile: "फोन", device_word_laptop: "लैपटॉप",
    sold_q: "क्या आपने इसे बेच दिया? कितने में?",
    sold_hint: "वैकल्पिक और गुमनाम — नाम या फोन नहीं। इससे सबको सही कीमत मिलती है।",
    sold_price: "आपको मिली कीमत (₹)",
    sold_pincode: "पिनकोड (वैकल्पिक)",
    sold_submit: "गुमनाम रूप से भेजें",
    sold_thanks: "धन्यवाद! आपकी जानकारी से आगे के अनुमान और सही होंगे।",
    sold_not_yet: "अभी नहीं बेचा",
    sold_yes: "हाँ, बेच दिया",
    basis_real: "असली कीमत",
    basis_estimate: "अनुमान",
    src_dealer_offer: "डीलर ऑफर: {p} ({n} ऑफर, पिछले 60 दिन)",
    src_sold: "हाल में बिका: {p} ({n} लोग, पिछले {d} दिन)",
    src_market_check: "मार्केट जाँच: {d}",
    src_adjusted: "इस मॉडल की {n} असली कीमतों पर आधारित, आपके वेरिएंट और स्थिति के हिसाब से।",
    src_estimate: "हमारे फॉर्मूले से अनुमान — इस डिवाइस की हाल की असली कीमतें अभी नहीं हैं।",
    src_partial: "अनुमान, आंशिक रूप से {n} हाल की असली कीमत(ों) पर आधारित।",
    src_list_title: "इस्तेमाल हुआ असली डेटा",
    kind_dealer_offer: "डीलर ऑफर", kind_sold: "यूज़र्स की बिक्री", kind_market_check: "मार्केट जाँच",
    latest_on: "आखिरी {d}",
    conf_reason_real_prices_used: "हाल की असली कीमतों पर आधारित।",
    tab_online: "ऑनलाइन अनुमान",
    tab_dealers: "नज़दीकी डीलर",
    channels_title: "आप कहाँ बेच सकते हैं",
    channel_band: "इस तरह के खरीदार की आम कीमत",
    channel_note: "आम कीमतों पर आधारित वैल्युएलिक्स अनुमान। सूची में किसी कंपनी का ऑफर नहीं। अंतिम कीमत जाँच के बाद।",
    nd_title: "अपने पास की सत्यापित दुकानों से असली ऑफर पाएं",
    nd_sub: "हम सिर्फ आपका डिवाइस, उसकी स्थिति और पिनकोड भेजते हैं। नाम या फोन नंबर नहीं।",
    nd_pincode: "आपका 6 अंकों का पिनकोड",
    nd_find: "डीलर खोजें",
    nd_location: "मेरी लोकेशन इस्तेमाल करें",
    nd_none: "अभी आपके पास कोई स्वीकृत डीलर नहीं है। पास का पिनकोड आज़माएं, या ऑनलाइन अनुमान देखें।",
    nd_open: "अभी खुला", nd_closed: "अभी बंद",
    nd_hours: "समय",
    nd_same_pincode: "वही पिनकोड", nd_nearby_area: "पास का इलाका", nd_same_district: "वही ज़िला", nd_same_region: "आपका क्षेत्र",
    nd_km: "{k} किमी दूर",
    nd_directions: "रास्ता देखें",
    nd_get_offer: "ऑफर मांगें",
    nd_ask_all: "चुने हुए सभी से मांगें ({n})",
    nd_sent: "रिक्वेस्ट गुमनाम रूप से भेजी गई। डीलर ऑफर भेजेंगे।",
    ds_kicker: "पास में बेचें · सबसे अच्छा कैश ऑफर",
    ds_title: "अपने पास की वेरिफ़ाइड दुकान से असली कैश ऑफर पाएं",
    ds_sub: "दुकानें अक्सर ऑनलाइन से ज़्यादा देती हैं। कुछ मिनट में ऑफर मिलाएं — बिल्कुल मुफ़्त।",
    ds_p1: "वेरिफ़ाइड दुकानें", ds_p2: "नंबर प्राइवेट रहेगा", ds_p3: "कोई फ़ीस नहीं",
    ds_locate: "मेरे पास की दुकानें दिखाएं",
    ds_pincode: "पिनकोड से खोजें",
    nd_or: "या",
    nd_searching: "आपके पास की दुकानें खोज रहे हैं…",
    nd_found: "आपके पास {n} दुकानें",
    nd_hint: "“मेरी लोकेशन इस्तेमाल करें” दबाएं या पिनकोड डालें।",
    nd_know_shop: "आपकी दुकान है? Valuelix डीलर बनें",
    nd_no_location: "इस फ़ोन पर लोकेशन उपलब्ध नहीं — कृपया पिनकोड डालें।",
    nd_loc_denied: "लोकेशन की अनुमति नहीं मिली — कृपया पिनकोड डालें।",
    nd_see_offers: "मेरे ऑफर देखें",
    nd_requested: "मांगा गया",
    mo_title: "मेरे डीलर ऑफर",
    mo_sub: "सबसे ज़्यादा ऑफर पहले। जब तक आप नीचे कोई एक डीलर न चुनें, आपका नंबर किसी को नहीं जाता।",
    mo_empty: "अभी कोई रिक्वेस्ट नहीं। कीमत देखें और \"नज़दीकी डीलर\" दबाकर दुकानों से ऑफर मांगें।",
    mo_waiting: "इनके ऑफर का इंतज़ार",
    mo_valid: "{d} तक मान्य",
    mo_expired: "समय खत्म",
    mo_share: "मेरा नंबर इस डीलर को दें",
    mo_phone: "आपका 10 अंकों का मोबाइल नंबर",
    mo_consent: "मैं अपना फोन नंबर सिर्फ इस एक डीलर को देने के लिए सहमत हूँ, ताकि वे मेरा डिवाइस बेचने के बारे में संपर्क कर सकें। मैं कभी भी वैल्युएलिक्स से इसे हटाने को कह सकता/सकती हूँ।",
    mo_share_btn: "सिर्फ इस डीलर को दें",
    mo_shared: "नंबर सिर्फ इस डीलर को दिया गया",
    mo_report: "इस डीलर की शिकायत करें",
    mo_report_reason: "क्या गलत हुआ?",
    mo_report_sent: "धन्यवाद। वैल्युएलिक्स इसकी जाँच करेगा।",
    mo_offer: "ऑफर",
    nav_dealers: "डीलरों के लिए",
    fd_title: "अपनी दुकान के लिए असली ग्राहक पाएं — मुफ्त",
    fd_sub: "आपके पास के ग्राहक वैल्युएलिक्स पर अपने डिवाइस की कीमत देखते हैं और सत्यापित दुकानों से ऑफर मांगते हैं। आपको डिवाइस, स्थिति और इलाका दिखता है, और आप अपना ऑफर भेजते हैं। ग्राहक का नंबर आपको तभी मिलता है जब वे आपकी दुकान चुनें।",
    fd_points: "अभी मुफ्त|सिर्फ सत्यापित दुकानें (हर आवेदन की जाँच)|ग्राहकों की प्राइवेसी सुरक्षित|फोन पर आसान डैशबोर्ड",
    fd_apply: "डीलर के रूप में आवेदन करें",
    fd_login: "डीलर लॉगिन",
    da_title: "डीलर आवेदन",
    da_shop: "दुकान की जानकारी", da_location: "लोकेशन", da_hours: "खुलने का समय", da_buy: "आप क्या खरीदते हैं", da_photos: "दुकान की फोटो", da_account: "लॉगिन जानकारी",
    da_shop_name: "दुकान का नाम", da_owner: "मालिक का नाम", da_phone: "दुकान का मोबाइल नंबर", da_address: "पूरा पता", da_area: "इलाका", da_city: "शहर", da_pincode: "पिनकोड",
    da_use_location: "मेरी मौजूदा लोकेशन लें (दुकान के अंदर खड़े होकर)", da_location_ok: "लोकेशन सेव हुई", da_maps: "या अपना Google Maps लिंक डालें (वैकल्पिक)",
    da_open: "खुलने का समय", da_close: "बंद होने का समय", da_closed_days: "बंद रहने का दिन",
    da_categories: "आप कौन सी श्रेणियाँ खरीदते हैं", da_brands: "आप कौन से ब्रांड खरीदते हैं (सभी के लिए खाली छोड़ें)", da_min: "न्यूनतम खरीद कीमत (₹)", da_max: "अधिकतम खरीद कीमत (₹)",
    da_pct: "वैल्युएलिक्स अनुमान का कितना % आप आमतौर पर देते हैं",
    da_front: "बोर्ड के साथ दुकान का सामने का हिस्सा (ज़रूरी)", da_photo2: "दुकान के अंदर (वैकल्पिक)", da_photo3: "एक और फोटो (वैकल्पिक)",
    da_email: "ईमेल", da_password: "पासवर्ड (कम से कम 8 अक्षर)",
    da_submit: "आवेदन भेजें",
    da_terms: "आवेदन करके आप नियमों से सहमत होते हैं और पुष्टि करते हैं कि जानकारी सही है। ग्राहकों को दिखाने से पहले वैल्युएलिक्स हर दुकान की जाँच करता है।",
    dl_title: "डीलर लॉगिन", dl_submit: "लॉगिन करें", dl_no_account: "नए डीलर? यहाँ आवेदन करें",
    dd_title: "डीलर डैशबोर्ड", dd_requests: "रिक्वेस्ट", dd_contacts: "मिले नंबर", dd_profile: "प्रोफाइल",
    dd_none: "अभी कोई रिक्वेस्ट नहीं। आपके पास के ग्राहक यहाँ दिखेंगे।",
    dd_estimate: "वैल्युएलिक्स अनुमान", dd_suggested: "आपके नियमों से सुझाव", dd_send: "ऑफर भेजें", dd_amount: "आपका ऑफर (₹)", dd_note: "नोट (वैकल्पिक)", dd_valid: "कितने दिन मान्य",
    dd_offer_sent: "ऑफर भेजा गया", dd_your_offer: "आपका ऑफर", dd_customer_phone: "ग्राहक का नंबर (आपको दिया गया)",
    dd_mark: "स्थिति बदलें", st_new: "नया", st_offered: "ऑफर भेजा", st_contacted: "संपर्क हुआ", st_sold: "बिका", st_closed: "बंद",
    dd_logout: "लॉगआउट", dd_save: "बदलाव सेव करें", dd_saved: "सेव हुआ",
    dd_add_photo: "फोटो जोड़ें", dd_photo_review: "नई फोटो वैल्युएलिक्स की जाँच के बाद दिखेंगी।", dd_pending: "जाँच बाकी", dd_approved: "स्वीकृत",
    dd_no_contacts: "अभी किसी ग्राहक ने आपको नंबर नहीं दिया।",
    nav_privacy: "गोपनीयता नीति", nav_disclaimer: "अस्वीकरण",
    privacy_title: "गोपनीयता नीति",
    disclaimer_page_title: "अस्वीकरण (डिस्क्लेमर)",
    legal_updated: "अंतिम अपडेट: 15 अक्टूबर 2026",
    consent_text: "हम वैकल्पिक एनालिटिक्स कुकीज़ से समझते हैं कि लोग वैल्युएलिक्स कैसे इस्तेमाल करते हैं। आपकी अनुमति के बिना कुछ भी ट्रैक नहीं होता।",
    consent_accept: "एनालिटिक्स स्वीकार करें",
    consent_reject: "केवल ज़रूरी",
    consent_more: "गोपनीयता नीति",
    cookie_settings: "कुकी सेटिंग",
    terms_title: "नियम और शर्तें",
    terms_updated: "अंतिम अपडेट: 15 अक्टूबर 2026",
  },
};

export const LABELS = {
  categories: {
    mobile: { en: "Mobile Phones", hi: "मोबाइल फोन" },
    laptop: { en: "Laptops", hi: "लैपटॉप" },
    tablet: { en: "Tablets", hi: "टैबलेट" },
    tv: { en: "TVs", hi: "टीवी" },
    gaming: { en: "Gaming Consoles", hi: "गेमिंग कंसोल" },
    camera: { en: "Cameras", hi: "कैमरा" },
    smartwatch: { en: "Smart Watches", hi: "स्मार्ट वॉच" },
    earbuds: { en: "Earbuds", hi: "ईयरबड्स" },
    appliance: { en: "Home Appliances", hi: "घरेलू उपकरण" },
    accessory: { en: "Accessories", hi: "एक्सेसरीज़" },
    others: { en: "Others", hi: "अन्य" },
  },
  conditions: {
    like_new: { en: "Like New", hi: "नए जैसा" },
    good: { en: "Good", hi: "अच्छा" },
    fair: { en: "Fair", hi: "ठीक-ठाक" },
    damaged: { en: "Damaged / Not Fully Working", hi: "खराब / पूरी तरह नहीं चलता" },
    working_perfectly: { en: "Working Perfectly", hi: "पूरी तरह चालू" },
    minor_cosmetic: { en: "Minor Cosmetic Wear", hi: "हल्के निशान" },
    display_issue: { en: "Display Issue", hi: "डिस्प्ले की दिक्कत" },
    not_working: { en: "Not Working", hi: "काम नहीं करता" },
    minor_issues: { en: "Minor Issues", hi: "छोटी दिक्कतें" },
    major_issues: { en: "Major Issues", hi: "बड़ी दिक्कतें" },
    visible_wear: { en: "Visible Wear", hi: "इस्तेमाल के निशान" },
  },
  conditionDesc: {
    like_new: { en: "Barely used, flawless", hi: "बहुत कम इस्तेमाल, बढ़िया" },
    good: { en: "Light use, all works", hi: "हल्का इस्तेमाल, सब चालू" },
    fair: { en: "Noticeable wear, works fine", hi: "काफ़ी इस्तेमाल, चलता ठीक है" },
    damaged: { en: "Broken or not fully working", hi: "टूटा या पूरी तरह नहीं चलता" },
    working_perfectly: { en: "Runs like new", hi: "नए जैसा चलता है" },
    minor_cosmetic: { en: "Small marks, works great", hi: "हल्के निशान, बढ़िया चलता है" },
    display_issue: { en: "Screen / display problem", hi: "स्क्रीन / डिस्प्ले की समस्या" },
    not_working: { en: "Dead / for parts", hi: "बंद / पुर्ज़ों के लिए" },
    minor_issues: { en: "Small faults, mostly fine", hi: "छोटी खराबी, ज़्यादातर ठीक" },
    major_issues: { en: "Needs repair", hi: "मरम्मत ज़रूरी" },
    visible_wear: { en: "Clear signs of use", hi: "इस्तेमाल के साफ निशान" },
  },
  years: {
    "2026": { en: "2026", hi: "2026" }, "2025": { en: "2025", hi: "2025" },
    "2024": { en: "2024", hi: "2024" }, "2023": { en: "2023", hi: "2023" },
    "2022": { en: "2022", hi: "2022" }, before_2022: { en: "Before 2022", hi: "2022 से पहले" },
    "2021": { en: "2021", hi: "2021" }, "2020": { en: "2020", hi: "2020" }, "2019": { en: "2019", hi: "2019" },
    "2018": { en: "2018", hi: "2018" },
    older: { en: "Older", hi: "इससे पुराना" },
  },
  accessories: {
    box: { en: "Original Box", hi: "ओरिजिनल बॉक्स" },
    charger: { en: "Charger", hi: "चार्जर" },
    both: { en: "Box + Charger", hi: "बॉक्स + चार्जर" },
    none: { en: "None", hi: "कुछ नहीं" },
    g_controller: { en: "Original Controller", hi: "ओरिजिनल कंट्रोलर" },
    g_cable: { en: "Power Cable", hi: "पावर केबल" },
    g_box: { en: "Box", hi: "बॉक्स" },
    g_complete: { en: "Complete Set", hi: "पूरा सेट" },
    g_missing: { en: "Missing Accessories", hi: "कुछ चीज़ें नहीं हैं" },
    e_case: { en: "Charging Case", hi: "चार्जिंग केस" },
    e_box: { en: "Box", hi: "बॉक्स" },
    e_cable: { en: "Cable", hi: "केबल" },
    e_none: { en: "None", hi: "कुछ नहीं" },
  },
  specFields: {
    storage: { en: "Storage", hi: "स्टोरेज" },
    ram: { en: "RAM", hi: "रैम" },
    processor: { en: "Processor", hi: "प्रोसेसर" },
    connectivity: { en: "Connectivity", hi: "कनेक्टिविटी" },
    screen_size: { en: "Screen Size", hi: "स्क्रीन साइज़" },
    edition: { en: "Edition", hi: "एडिशन" },
    kit: { en: "What are you selling?", hi: "आप क्या बेच रहे हैं?" },
    appliance_type: { en: "Appliance Type", hi: "उपकरण का प्रकार" },
    capacity: { en: "Capacity", hi: "क्षमता" },
    ac_capacity: { en: "Capacity", hi: "क्षमता" },
    fridge_type: { en: "Type", hi: "प्रकार" },
    wm_type: { en: "Type", hi: "प्रकार" },
    ac_type: { en: "Type", hi: "प्रकार" },
    ac_inverter: { en: "Compressor", hi: "कंप्रेसर" },
    mw_type: { en: "Type", hi: "प्रकार" },
  },
  specOptions: {
    st_32: { en: "32GB", hi: "32GB" }, st_64: { en: "64GB", hi: "64GB" }, st_128: { en: "128GB", hi: "128GB" },
    st_256: { en: "256GB", hi: "256GB" }, st_512: { en: "512GB", hi: "512GB" }, st_1tb: { en: "1TB", hi: "1TB" },
    lram_4: { en: "4GB", hi: "4GB" }, lram_8: { en: "8GB", hi: "8GB" }, lram_16: { en: "16GB", hi: "16GB" },
    lram_32: { en: "32GB", hi: "32GB" }, lram_64: { en: "64GB", hi: "64GB" },
    lst_256ssd: { en: "256GB SSD", hi: "256GB SSD" }, lst_512ssd: { en: "512GB SSD", hi: "512GB SSD" },
    lst_1tbhdd: { en: "1TB HDD", hi: "1TB HDD" }, lst_1tbssd: { en: "1TB SSD", hi: "1TB SSD" }, lst_2tb: { en: "2TB", hi: "2TB" },
    cpu_i3: { en: "Intel i3", hi: "Intel i3" }, cpu_i5: { en: "Intel i5", hi: "Intel i5" }, cpu_i7: { en: "Intel i7", hi: "Intel i7" },
    cpu_i9: { en: "Intel i9", hi: "Intel i9" }, cpu_r3: { en: "AMD Ryzen 3", hi: "AMD Ryzen 3" }, cpu_r5: { en: "AMD Ryzen 5", hi: "AMD Ryzen 5" },
    cpu_r7: { en: "AMD Ryzen 7", hi: "AMD Ryzen 7" }, cpu_m1: { en: "Apple M1", hi: "Apple M1" }, cpu_m2: { en: "Apple M2", hi: "Apple M2" }, cpu_m3: { en: "Apple M3", hi: "Apple M3" },
    tst_32: { en: "32GB", hi: "32GB" }, tst_64: { en: "64GB", hi: "64GB" }, tst_128: { en: "128GB", hi: "128GB" },
    tst_256: { en: "256GB", hi: "256GB" }, tst_512: { en: "512GB", hi: "512GB" },
    tcon_wifi: { en: "WiFi Only", hi: "केवल WiFi" }, tcon_cell: { en: "WiFi + Cellular", hi: "WiFi + सेल्युलर" },
    scr_24: { en: "24 inch", hi: "24 इंच" }, scr_32: { en: "32 inch", hi: "32 इंच" }, scr_40: { en: "40 inch", hi: "40 इंच" },
    scr_43: { en: "43 inch", hi: "43 इंच" }, scr_50: { en: "50 inch", hi: "50 इंच" }, scr_55: { en: "55 inch", hi: "55 इंच" },
    scr_65: { en: "65 inch", hi: "65 इंच" }, scr_75: { en: "75 inch or larger", hi: "75 इंच या बड़ा" },
    ged_disc: { en: "Disc Edition", hi: "डिस्क एडिशन" }, ged_digital: { en: "Digital Edition", hi: "डिजिटल एडिशन" },
    kit_body: { en: "Body Only", hi: "केवल बॉडी" }, kit_lens: { en: "Body + Lens / Kit", hi: "बॉडी + लेंस / किट" },
    wcon_gps: { en: "GPS", hi: "GPS" }, wcon_cell: { en: "GPS + Cellular", hi: "GPS + सेल्युलर" },
    app_ac: { en: "Air Conditioner", hi: "एयर कंडीशनर" }, app_fridge: { en: "Refrigerator", hi: "रेफ्रिजरेटर" }, app_wash: { en: "Washing Machine", hi: "वॉशिंग मशीन" },
    app_micro: { en: "Microwave", hi: "माइक्रोवेव" }, app_tv: { en: "TV", hi: "टीवी" }, app_other: { en: "Other", hi: "अन्य" },
    fcap_small: { en: "Below 200 L", hi: "200 L से कम" }, fcap_medium: { en: "200 – 400 L", hi: "200 – 400 L" }, fcap_large: { en: "Above 400 L", hi: "400 L से ऊपर" },
    ft_single: { en: "Single Door", hi: "सिंगल डोर" }, ft_double: { en: "Double Door", hi: "डबल डोर" }, ft_sbs: { en: "Side-by-Side", hi: "साइड-बाय-साइड" }, ft_french: { en: "French Door", hi: "फ्रेंच डोर" },
    wcap_small: { en: "Below 7 kg", hi: "7 किग्रा से कम" }, wcap_medium: { en: "7 – 8 kg", hi: "7 – 8 किग्रा" }, wcap_large: { en: "Above 8 kg", hi: "8 किग्रा से ऊपर" },
    wm_fully: { en: "Fully Automatic", hi: "फुली ऑटोमैटिक" }, wm_semi: { en: "Semi Automatic", hi: "सेमी ऑटोमैटिक" }, wm_front: { en: "Front Load", hi: "फ्रंट लोड" }, wm_top: { en: "Top Load", hi: "टॉप लोड" },
    acc1: { en: "1 Ton", hi: "1 टन" }, acc15: { en: "1.5 Ton", hi: "1.5 टन" }, acc2: { en: "2 Ton", hi: "2 टन" }, accother: { en: "Other", hi: "अन्य" },
    act_split: { en: "Split", hi: "स्प्लिट" }, act_window: { en: "Window", hi: "विंडो" },
    acinv: { en: "Inverter", hi: "इन्वर्टर" }, acnon: { en: "Non-Inverter", hi: "नॉन-इन्वर्टर" },
    mwcap_s: { en: "Below 20 L", hi: "20 L से कम" }, mwcap_m: { en: "20 – 30 L", hi: "20 – 30 L" }, mwcap_l: { en: "Above 30 L", hi: "30 L से ऊपर" },
    mw_solo: { en: "Solo", hi: "सोलो" }, mw_grill: { en: "Grill", hi: "ग्रिल" }, mw_conv: { en: "Convection", hi: "कन्वेक्शन" },
  },
};

Object.assign(STRINGS.en, MORE.en);
Object.assign(STRINGS.hi, MORE.hi);
Object.entries(MORE_LABELS).forEach(([g, v]) => { LABELS[g] = { ...(LABELS[g] || {}), ...v }; });

const LangContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => { try { return localStorage.getItem("vlx_lang") || "en"; } catch { return "en"; } });
  const setLang = useCallback((l) => {
    setLangState(l);
    try { localStorage.setItem("vlx_lang", l); } catch { /* storage blocked */ }
  }, []);
  const t = useCallback((key, params) => {
    let v = STRINGS[lang][key] ?? STRINGS.en[key] ?? key;
    if (params) Object.entries(params).forEach(([k, x]) => { v = v.replaceAll(`{${k}}`, String(x)); });
    return v;
  }, [lang]);
  const label = useCallback((group, id) => {
    const g = LABELS[group];
    if (!g || !g[id]) return id;
    return g[id][lang] || g[id].en;
  }, [lang]);
  return (
    <LangContext.Provider value={{ lang, setLang, t, label }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
}
